import getTimezoneOffset from 'date-fns-tz/getTimezoneOffset'

function AssetUploadLocation (timeZone): string {

  if(timeZone === 'America/Halifax')
    return 'US East'
  else if(timeZone === 'America/Anchorage' || timeZone === 'Pacific/Honolulu')
    return 'US West (California)'
  else if(timeZone === 'America/St_Lucia')
    return 'US West (Oregon)'
    
  const offset = getTimezoneOffset(timeZone, new Date());
  
  const OffSetNumber = (Math.floor(offset / 60000))/60;
  
  if(OffSetNumber <= -7)
    return 'US West (California)'
  else if(OffSetNumber >-7 && OffSetNumber <=-4)
    return 'US West (Oregon)'
  else if(OffSetNumber >-4 && OffSetNumber <=-3)
    return 'US East'  
  else if(OffSetNumber >-3 && OffSetNumber <=-1)
    return 'South America (Sao Paulo)'
  else if(OffSetNumber >-1 && OffSetNumber <=3)
    return 'Europe' 
  else if(OffSetNumber >3 && OffSetNumber <=7)
    return 'Asia Pacific (Singapore)'
  else if(OffSetNumber > 7)
    return 'Asia Pacific (Tokyo)'

  return 'US West (California)'

}

export default AssetUploadLocation
